module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    class: 'modal fade modal-' + this.type,
    attrs: {
      "id": "bsModal",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "bsModalLabel",
      "data-toggle": "modal",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content box-success"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('i', {
    staticClass: "icon-modal"
  }), _vm._m(0), _vm._v(" "), _c('h4', {
    staticClass: "modal-title",
    attrs: {
      "id": "bsModalLabel"
    }
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('p', {
    staticClass: "modal-description"
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-description"
  }, [_vm._v("\n             " + _vm._s(_vm.description) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [(this.cancelText) ? _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(_vm._s(_vm.cancelText))]) : _vm._e(), _vm._v(" "), _c('button', {
    class: 'btn btn-' + this.type,
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.confirm
    }
  }, [_vm._v(_vm._s(_vm.confirmText))])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-56261b8e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modal/Modal.vue
// module id = 520
// module chunks = 1